import React, { FC, useEffect, useState } from "react";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import dayjs from "dayjs";
import PortalRegistrationStarHealth from "../../../../components/patient/Portal Registration/StarHealth/PortalRegistrationStarHealth";
import PortalSubmissionModal from "../../../../components/patient/PreAuth/PortalSubmissionModal";
import ManuallyIdModal from "../../../../components/patient/PreAuth/ManuallyIdModal";
import PortalSubmitModal from "../../../../components/patient/PreAuth/PortalSubmitModal";
import {
  fetchStepperData,
  getPortalDataStarhealth,
  getVisitStageStates,
} from "../../../../models/preAuthSlice";
import {
  getBasicDetails,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import { submitId } from "../../../../apis/patientService";
import ManuallyRegistrationIdPortal from "../../../../components/patient/PreAuth/ManuallyRegistrationIdPortal";
import { registerPatientPortalStarHealth } from "../../../../apis/SchemeService/STARHEALTH/starHealthService";
import PortalClaimValidationModal from "../../../../components/patient/Portal Registration/PortalClaimValidationModal";
import {
  handlePortalClaimValidationFlow,
  updatePortalClaimValidation,
} from "../../../../utils/portalClaimValidation";

type PortalRegistrationStarHealthContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

const PortalRegistrationStarHealthContainer: FC<
  PortalRegistrationStarHealthContainerProps
> = ({ activeKey, sseData, sseUpdateCount }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuth } = useSelector((state: RootState) => state);
  const [editRegId, setEditRegId] = useState<boolean>(false);
  const [isSubmittedOnPortal, setIsSubmittedOnPortal] =
    useState<boolean>(false);
  const [isManuallyEnteredId, setIsManuallyEnteredId] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const [manuallyRegistrationIdPortal, setManuallyRegistrationIdPortal] =
    useState<boolean>(false);
  const [showRegistrationId, setShowRegistrationId] = useState<boolean>(false);
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const [validationRes, setValidationRes] = useState<any>(null);
  const [isValidationLoading, setIsValidationLoading] = useState(false);
  const [registrationValidationStatus, setRegistrationValidationStatus] =
    useState<any>(null);

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]))
  );

  const fetchStepperForStatus = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const isPortalRegistrationTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId
    );

    return (
      currentStage?.visitStage?.toUpperCase() ===
      "Portal registration"?.toUpperCase()
    );
  };

  useEffect(() => {
    if (patients) {
      form.setFieldsValue({
        beneficiaryId:
          preAuth?.portalData?.beneficiaryId ||
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.beneficiaryId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId,
        patientOpdIpdNumber:
          patients?.fetchBasicDetails?.visitInfoResponse?.opNumber,
        medicalId:
          preAuth?.portalData?.medicalId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId,
        registrationDate: preAuth?.portalData?.registrationDate
          ? dayjs(preAuth?.portalData?.registrationDate, dateFormat)
          : patients?.fetchBasicDetails?.visitInfoResponse?.doa
          ? dayjs(
              patients?.fetchBasicDetails?.visitInfoResponse?.doa,
              dateFormat
            )
          : null,
        policyName:
          preAuth?.portalData?.policyName ||
          patients?.fetchBasicDetails?.patientResponse
            ?.patientSchemeNewResponseList?.[0]?.policyName ||
          null,
        policyNumber:
          preAuth?.portalData?.policyNumber ||
          patients?.fetchBasicDetails?.patientResponse
            ?.patientSchemeNewResponseList?.[0]?.policyNumber ||
          null,
        claimRefNo: preAuth?.portalData?.claimRefNo,
        policyDate: preAuth?.portalData?.policyDate
          ? dayjs(preAuth?.portalData?.policyDate, dateFormat)
          : null,
        policyStartDate: preAuth?.portalData?.policyStartDate
          ? dayjs(preAuth?.portalData?.policyStartDate, dateFormat)
          : patients?.fetchBasicDetails?.patientResponse
              ?.patientSchemeNewResponseList?.[0]?.policyStartDate
          ? dayjs(
              patients?.fetchBasicDetails?.patientResponse
                ?.patientSchemeNewResponseList?.[0]?.policyStartDate,
              dateFormat
            )
          : null,
        policyEndDate: preAuth?.portalData?.policyEndDate
          ? dayjs(preAuth?.portalData?.policyEndDate, dateFormat)
          : (patients?.fetchBasicDetails?.patientResponse
              ?.patientSchemeNewResponseList?.[0]?.policyEndDate &&
              dayjs(
                patients?.fetchBasicDetails?.patientResponse
                  ?.patientSchemeNewResponseList?.[0]?.policyEndDate,
                dateFormat
              )) ||
            null,
        claimType: preAuth?.portalData?.claimType || "NON-COVID",
        policyType: preAuth?.portalData?.policyType || "INDIVIDUAL",
        policySource:
          patients?.fetchBasicDetails?.patientResponse
            ?.patientSchemeNewResponseList?.[0]?.policySource || null,
        registrationId: preAuth?.portalData?.schemeRegistrationId,
      });
    }
  }, [patients?.fetchBasicDetails, preAuth?.portalData]);

  const fetchPortalData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      const resp = await dispatch(
        getPortalDataStarhealth({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );

      if (getPortalDataStarhealth.rejected.match(resp)) {
        errorMessage("Please try again after sometime");
      }
    }
  };

  const fetchVisitStageIds = async () => {
    if (currentActiveStage?.visitStageId) {
      const resp = await dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId })
      );

      if (getVisitStageStates.rejected.match(resp)) {
        errorMessage("Please try again after sometime");
      }
    }
  };

  useEffect(() => {
    if (!isPortalRegistrationTabActive()) return;

    fetchPortalData();
    fetchVisitStageIds();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    currentActiveStage?.visitStageId,
    activeKey,
  ]);

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (!isPortalRegistrationTabActive()) return;

    // fetchStepperForStatus();
    // getTimelineDetail();
  }, [
    preAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  
  const isFetchingSseData = React.useRef(false);
  const fetchDataForSse = async () => {
    if (isFetchingSseData.current) {
      return;
    }
    try {
      isFetchingSseData.current = true;
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        // dispatch(
        //   getBasicDetails({
        //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        //   })
        // );
        await fetchPortalData();
        fetchStepperForStatus();
        await getTimelineDetail();
      }
    } finally {
      isFetchingSseData.current = false; // Reset fetching flag
    }
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    let pollCount = 0;
    const maxPolls = 24;
    const modifiedAt = preAuth?.portalData?.modifiedAt;

    const modifiedTime = new Date(modifiedAt).getTime();
    const now = Date.now();
    const diffSeconds = (now - modifiedTime) / 1000;

    if (
      preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
        "portal registration" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "initiated" &&
      !preAuth?.portalData?.schemeRegistrationId &&
      diffSeconds <= 78
    ) {
      intervalId = setInterval(() => {
        pollCount++;
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          fetchPortalData();
        }

        if (preAuth?.portalData?.schemeRegistrationId) {
          if (intervalId) clearInterval(intervalId);
          if (timeoutId) clearTimeout(timeoutId);
        }

        if (pollCount >= maxPolls) {
          if (intervalId) clearInterval(intervalId);
          setShowRegistrationId(true);
          // form.setFieldValue("registrationId", "-");
        }
      }, 5000);

      timeoutId = setTimeout(() => {
        if (intervalId) clearInterval(intervalId);
        setShowRegistrationId(true);
        // form.setFieldValue("registrationId", "-");
      }, 120000);
    } else if (
      preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
        "portal registration" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "initiated" &&
      !preAuth?.portalData?.schemeRegistrationId &&
      diffSeconds > 78
    ) {
      setShowRegistrationId(true);
    } else if (
      preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
        "portal registration" &&
      preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
        "manually submitted" &&
      !preAuth?.portalData?.schemeRegistrationId
    ) {
      setShowRegistrationId(true);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    preAuth?.portalData?.modifiedAt,
    preAuth?.portalData?.schemeRegistrationId,
    preAuth?.portalData?.stateName,
    preAuth?.portalData?.visitStagesName,
  ]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (
  //       patients?.fetchBasicDetails?.casesResponse?.id &&
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id
  //     ) {
  //       if (
  //         preAuth?.portalData?.schemeRegistrationId == null &&
  //         preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
  //           "portal registration" &&
  //         preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
  //           "initiated"
  //       ) {
  //         fetchPortalData();
  //       }
  //     }
  //   }, 10000);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.id,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //   preAuth?.portalData,
  // ]);

  const handleEditRegId = () => {
    setEditRegId(!editRegId);
  };

  const handleManuallyIdEnter = () => {
    setIsSubmittedOnPortal(false);
    setIsManuallyEnteredId(true);
  };

  const handleCancelPortal = () => {
    setIsSubmittedOnPortal(false);
    setOpen(true);
  };

  const handleCancelManuallyId = () => {
    setIsManuallyEnteredId(false);
  };

  const handleOk = () => {
    setOpen(false);
  };

  const handleRegistrationCancel = () => {
    setOpen(false);
    setIsSubmittedOnPortal(false);
  };

  const handleRegistration = () => {
    if (patients?.fetchBasicDetails?.casesResponse.integratedWithPortal) {
      setIsSubmittedOnPortal(true);
    } else {
      setManuallyRegistrationIdPortal(true);
    }
  };

  const handleSubmitId = async (values: any) => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
      ) {
        const formData = {
          registrationId: values.registrationId,
          claimId: null,
        };
        const submitData = await submitId(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          formData
        );
        if (submitData) {
          if (editRegId) {
            successMessage("Registration Id updated successfully");
          } else {
            successMessage(
              "Registration is Successful, Please Proceed further"
            );
          }
          setEditRegId(false);
          await fetchPortalData();
          fetchStepperForStatus();
        }
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handleSaveManually = async (values: any) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const registrationFormValues = await form.validateFields();
        const updatedData = {
          ...registrationFormValues,
          registrationDate: registrationFormValues?.registrationDate
            ? dayjs(registrationFormValues?.registrationDate).format(dateFormat)
            : null,
          policyInceptionDate: registrationFormValues?.policyInceptionDate
            ? dayjs(registrationFormValues?.policyInceptionDate).format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          policyStartDate: registrationFormValues?.policyStartDate
            ? dayjs(registrationFormValues?.policyStartDate).format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          policyEndDate: registrationFormValues?.policyEndDate
            ? dayjs(registrationFormValues?.policyEndDate).format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          manualRegistration: true,
          schemeRegistrationId: values?.manualId,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        setIsLoading(true);
        await registerPatientPortalStarHealth(
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          updatedData
        );
        successMessage("Registered Successfully");
        setManuallyRegistrationIdPortal(false);
        setIsLoading(false);
        await fetchPortalData();
        fetchStepperForStatus();
        await getTimelineDetail();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please fill all details before submitting");
      } else {
        errorMessage("Please try again later");
      }
      setIsLoading(false);
    }
    setIsManuallyEnteredId(false);
    setManuallyRegistrationIdPortal(false);
  };

  const handleSaveModalOption = async () => {
    try {
      const values = await form.validateFields();
      setIsLoading(true);
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const updatedData = {
          ...values,
          registrationDate: values?.registrationDate
            ? dayjs(values?.registrationDate).format(dateFormat)
            : null,
          policyInceptionDate: values?.policyInceptionDate
            ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyStartDate: values?.policyStartDate
            ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyEndDate: values?.policyEndDate
            ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        await registerPatientPortalStarHealth(
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          updatedData
        );
        successMessage("Registered Successfully");
        await fetchPortalData();
        fetchStepperForStatus();
        await getTimelineDetail();
      }
      setIsLoading(false);
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please fill all details before submitting");
      } else {
        errorMessage("Please try again later");
      }
      setIsLoading(false);
    }
    setOpen(false);
  };

  const isRegistrationSubmitted = Boolean(
    preAuth?.portalData?.schemeRegistrationId,
  );
  const showVerifyButton = isRegistrationSubmitted;

  const handleClaimValidation = async () => {
    await handlePortalClaimValidationFlow({
      scheme: "STAR_HEALTH",
      caseId: patients?.fetchBasicDetails?.casesResponse?.id,
      visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      healthcareId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
      schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      claimId: preAuth?.portalData?.schemeRegistrationId,
      portalData: preAuth?.portalData,
      patients,
      setIsValidationLoading,
      setValidationRes,
      setRegistrationValidationStatus,
      setIsValidationModalOpen,
    });
  };

  const handleUpdateClaimValidation = async (data: any) => {
    try {
      await updatePortalClaimValidation(
        "STAR_HEALTH",
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        data,
      );
      successMessage("Details Updated Successfully");
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        await dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
      await fetchPortalData();
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  return (
    <div>
      <PortalRegistrationStarHealth
        editRegId={editRegId}
        handleEditRegId={handleEditRegId}
        handleSubmitId={handleSubmitId}
        handleRegistration={handleRegistration}
        form={form}
        portalData={preAuth?.portalData}
        showRegistrationId={showRegistrationId}
        isSubmitted={isRegistrationSubmitted}
        showVerifyButton={showVerifyButton}
        isValidationLoading={isValidationLoading}
        registrationValidationStatus={registrationValidationStatus}
        handleClaimValidation={handleClaimValidation}
      />
      <PortalSubmissionModal
        open={isSubmittedOnPortal}
        title={"Is Registration Already Submitted on Portal?"}
        handleCancel={handleCancelPortal}
        handleSave={handleManuallyIdEnter}
      />
      <ManuallyIdModal
        open={isManuallyEnteredId}
        title={"Enter Registration Id"}
        handleCancel={handleCancelManuallyId}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />
      <PortalSubmitModal
        open={open}
        title={"Do You want to Register PreAuth?"}
        handleOk={handleOk}
        handleCancel={handleRegistrationCancel}
        handleSave={handleSaveModalOption}
        isLoading={isLoading}
      />

      <ManuallyRegistrationIdPortal
        open={manuallyRegistrationIdPortal}
        title={"Enter Registration Id"}
        handleCancel={() => setManuallyRegistrationIdPortal(false)}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />

      <PortalClaimValidationModal
        open={isValidationModalOpen}
        onCancel={() => setIsValidationModalOpen(false)}
        validationRes={validationRes}
        scheme="STAR_HEALTH"
        onUpdate={handleUpdateClaimValidation}
      />
    </div>
  );
};

export default PortalRegistrationStarHealthContainer;
